import { CURRENCIES } from '@wix/wix-vod-constants/dist/common/currencies';
import { BM_ADDITIONAL_CURRENCIES } from '@wix/wix-vod-constants/dist/common/bm-additional-currencies';

export {
  DEFAULT_CURRENCY,
} from '@wix/wix-vod-constants/dist/common/currencies';

const getCurrenciesInfo = () => ({
  ...CURRENCIES,
  ...BM_ADDITIONAL_CURRENCIES,
});

export default getCurrenciesInfo;
